import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from "antd"
import queryString from "query-string"
import { listPartner } from "../../../../services/api/3dApi"
import { v4 as uuidV4 } from 'uuid'

const { Option } = Select

class BatchesPartnerSew extends Component {
    constructor(props) {
        super(props)

        this.state = {
            partners: [],
            errPartner: ''
        }
    }

    componentDidMount() {
        this._fetchPartnersSew()
    }

    _fetchPartnersSew = async () => {
        try {
            const payloadSew = {
                type: 'sewing_partner',
                hidden: false,
                limit: 1000
            }

            const querySew = queryString.stringify(payloadSew)

            const { data: responsePartners } = await listPartner(querySew)

            const { success, error, data } = responsePartners

            if (!success) {
                this.setState({
                    errPartner: error
                })

                return
            }

            const newPartnersSew = data.partners.flatMap(partner => {
                if (partner.has_groups) {
                    return partner.groups.map(group => ({
                        ...partner,
                        ...group,
                        idx: uuidV4(),
                        partnerId: partner._id,
                        partnerName: partner.name,
                        groupId: group._id,
                    }))
                }

                return { ...partner, idx: uuidV4(), partnerName: partner.name, partnerId: partner._id }
            })

            this.setState({
                partners: newPartnersSew,
                errPartner: ''
            })
        } catch (e) {
            this.setState({})
        }
    }

    _handleChangePartnerSew = (name, value) => {
        const { onChangePartner, onChangeCheckBox } = this.props
        const { partners = [] } = this.state

        const listPartnerSelected = Array.isArray(partners) && partners.length > 0 ?
            partners.filter(p => value.includes(p.idx))
                .map(p => ({ sewing_partner: p.partnerId, sewing_group: p.groupId, }))
            : []

        onChangePartner({
            without_sewing_group: value.includes('without_sewing_group'),
            without_sewing_partner: value.includes('without_sewing_partner'),
            mutiple_sewing_partner: listPartnerSelected,
            // sewing_group: '',
            // sewing_partner: '',
        })

        if(value.includes('without_sewing_group')){
            onChangeCheckBox(false)
        }else{
            onChangeCheckBox(true)
        }
    }

    render() {
        const { partners } = this.state
        const { filters = {}, disabled = false } = this.props
        const { without_sewing_group = false, without_sewing_partner = false, mutiple_sewing_partner = [] } = filters || {}

        return (
            <div className='col-12 col-xl-2 mb-3'>
                <label className="font-weight-bold d-block">Nhóm may</label>
                <Select
                    dropdownClassName='custom-select-partner'
                    onChange={(value) => this._handleChangePartnerSew('sewing_partner', value)}
                    defaultValue={[]} style={{ width: '100%' }}
                    placeholder="Nhóm may" mode='multiple' allowClear showArrow showSearch
                    disabled={disabled}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {/* <Option value=''>Tất cả</Option> */}
                    <Option disabled={without_sewing_partner || mutiple_sewing_partner.length > 0} value='without_sewing_group'>Chưa có nhóm may</Option>
                    <Option disabled={without_sewing_group || mutiple_sewing_partner.length > 0} value='without_sewing_partner'>Chưa có đối tác may</Option>
                    {
                        partners.length > 0 && partners.map(item => {
                            return (
                                <Option key={item.idx} disabled={without_sewing_group || without_sewing_partner} value={item.idx}>
                                    {
                                        !!item.has_groups ? `${item.partnerName} - ${item.name}` : item.name
                                    }
                                </Option>
                            )
                        })
                    }
                </Select>
            </div>
        )
    }
}

BatchesPartnerSew.propTypes = {
    onChangePartner: PropTypes.func.isRequired
}

export default BatchesPartnerSew